import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Button, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { Form, SimpleTextField, useModel, useSettings, Utils } from 'app/main/components';

interface TagsEditDialogProps {
	/** The base model */
	baseModel?: any;
	/** If true the dialog is in add mode and not into edit */
	isAdd?: boolean;
	/** Function used to refresh the related view */
	updateRefresh?: () => void;
}

export function showTagsEditDialog(props: TagsEditDialogProps) {
	return openDialog({
		children: <TagsEditDialog {...props} />,
		fullWidth: true,
		maxWidth: 'sm',
		onClose: () => {}
	});
}

export default function TagsEditDialog({ baseModel, isAdd, updateRefresh }: TagsEditDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings('tags');

	const modelProps = useModel({
		baseModel: { tags_id: !isAdd ? baseModel.tags_id : uuidv4() },
		baseModifiedModel: baseModel,
		settings,
		isEdit: true,
		isAdd
	});

	const save = () => {
		modelProps.save({
			onSuccess: () => {
				dispatch(Utils.alertSuccessMsg(t, isAdd ? 'ALERT_ADD_SUCCESS' : 'ALERT_UPDATE_SUCCESS'));
				dispatch(closeDialog());
				updateRefresh?.();
			}
		});
	};

	return (
		<>
			<DialogTitle>
				<FormattedMessage
					id="editDialog.title"
					defaultMessage={t(isAdd ? 'DIALOG_TITLE_ADD' : 'DIALOG_TITLE_UPDATE')}
					values={{ module: t('MODULE_TAGS_NAME') }}
				/>
			</DialogTitle>
			<DialogContent>
				<Form id="editDialog" onSubmit={save}>
					<Grid size={12}>
						<SimpleTextField
							name="tags_title"
							label={t('DETAILS_TAGS_FIELD_TITLE')}
							value={modelProps.model.tags_title}
							isEdit
							sendChange={modelProps.sendChange}
							required
							validationError={t('ERROR_TEXT_REQUIRED')}
						/>
					</Grid>
				</Form>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				<Button type="submit" form="editDialog" color="secondary">
					{t('DIALOG_ACTION_CONFIRM')}
				</Button>
			</DialogActions>
		</>
	);
}
